import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { enableTotp, clearEnableTotp } from 'redux/users/actions';

import AuthCode from 'react-auth-code-input';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import './TwoFactorConfirmation.css';

function TwoFactorConfirmation(props) {
  const {
    setActiveStep,
    enableTotp,
    clearEnableTotp,
    enableTotpSuccess,
    enableTotpError,
    onClose,
  } = props;
  const [tokenValue, setTokenValue] = useState(null);
  const { t } = useTranslation();

  if (enableTotpSuccess) return (
    <div className="two-factor-confirmation__component success">
      <strong>Two-Factor Authentication Is On.</strong>
      <div>
        {t("We'll ask for a code during every attempted login from any device or browser.")}
      </div>

      <div className="buttons-block">
        <Button small onClick={onClose}>{t("Done")}</Button>
      </div>
    </div>
  );

  if (enableTotpError) return (
    <div className="two-factor-confirmation__component success">
      <CommonMessage error>{t("Verification code is incorrect. Please try again")}</CommonMessage>
      <div className="buttons-block">
        <Button
          small
          borderedBlue
          onClick={clearEnableTotp}
        >
          &#10094;&nbsp;&nbsp;{t("Back")}
        </Button>
      </div>
    </div>
  );

  return (
    <div className="two-factor-confirmation__component">
      <div className="text">
        {t("Please enter the confirmation code you see on your authentication app.")}
      </div>

      <div className="inputs-wrapper">
        <AuthCode onChange={value => setTokenValue(value)} />
      </div>

      <div className="buttons-block">
        <Button
          small
          disabled={!(tokenValue && tokenValue.length === 6)}
          onClick={() => {
            enableTotp(tokenValue);
          }}
        >
          {t("Continue")}
        </Button>

        <Button
          small
          borderedBlue
          onClick={() => { setActiveStep('code'); }}
        >
          &#10094;&nbsp;&nbsp;{t("Back")}
        </Button>
      </div>

    </div>
  );
}

TwoFactorConfirmation.propTypes = {
  setActiveStep: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  enableTotp: PropTypes.func.isRequired,
  clearEnableTotp: PropTypes.func.isRequired,
  enableTotpSuccess: PropTypes.object,
  enableTotpError: PropTypes.object,
};

TwoFactorConfirmation.defaultProps = {
  enableTotpSuccess: null,
  enableTotpError: null,
};

const mapStateToProps = state => (
  {
    enableTotpSuccess: state.usersReducer.enableTotpSuccess,
    enableTotpError: state.usersReducer.enableTotpError,
  }
);

export default connect(
  mapStateToProps,
  {
    enableTotp,
    clearEnableTotp,
  },
)(TwoFactorConfirmation);
